import { z } from "zod";
import { env } from "../../env";
import {
  parseServiceInput,
  parseServiceOutput,
  requestConfig,
} from "../../globals";
import { type AccountProfile, accountProfile } from "../schemas/accountProfile";

export const getAccountProfileProps = z
  .object({ token: z.string() })
  .extend(requestConfig.shape);

export type GetAccountProfileProps = z.infer<typeof getAccountProfileProps>;

export const getAccountProfile = async (
  args: GetAccountProfileProps,
): Promise<AccountProfile> => {
  const {
    endpoint = env.ACCOUNT_SERVICE_URL,
    token,
    proxyAuthSecret,
  } = parseServiceInput(getAccountProfileProps, args);

  const headers = new Headers({
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
    ...(proxyAuthSecret && { "X-NG-Proxy-Auth": proxyAuthSecret }),
  });

  const response = await fetch(`${endpoint}/v1/account/profile`, {
    method: "GET",
    headers,
  });

  return parseServiceOutput(response, accountProfile, {
    code: "MALFORMED_ACCOUNT",
    message: "Account is malformed",
  });
};
